var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.order
    ? _c(
        "div",
        {
          staticClass: "mb35 p20 brdr-1 brdr-cl-primary bg-cl-white",
          staticStyle: { "border-radius": "30px" }
        },
        [
          _c("div", { staticClass: "row mb15" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-2 col-lg-1" },
              [_c("return-icon", { staticClass: "p12 icon pointer" })],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-sm-7" }, [
              _c("h3", { staticClass: "m0 mb5 mt5" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("Order #{id}", { id: _vm.order.entity_id })) +
                    "\n        "
                ),
                _c(
                  "span",
                  {
                    staticClass:
                      "brdr-1 brdr-cl-bg-secondary py5 px10 ml20 sans-serif fs-medium-small weight-400 cl-secondary"
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("capitalize")(_vm.$t(_vm.order.status))) +
                        "\n        "
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3" },
              [
                _c(
                  "div",
                  { staticStyle: { "text-align": "right" } },
                  [
                    _c(
                      "button-full",
                      {
                        nativeOn: {
                          click: function($event) {
                            return _vm.createComplaint($event)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("RMA / Return")) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("create-complaint", {
                  attrs: { typeOptions: _vm.typeOptions }
                }),
                _vm._v(" "),
                _c("complaint-created")
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row fs16 mb20" }, [
            _c("div", { staticClass: "col-xs-12 h4" }, [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm._f("date")(_vm.order.created_at, "LLL", _vm.storeView)
                  )
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row fs16 mb35" }, [
            _c("div", { staticClass: "col-xs-12 h4" }, [
              _c("h4", [_vm._v(_vm._s(_vm.$t("Items ordered")))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "items-table brdr-1 brdr-cl-bg-secondary" },
                [
                  _c(
                    "table",
                    { staticClass: "brdr-none brdr-cl-bg-secondary" },
                    [
                      _c("thead", [
                        _c("tr", [
                          _c("th", { staticClass: "sans-serif lh20" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("Product Name")) +
                                "\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "sans-serif lh20" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("Model BP")) +
                                "\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "sans-serif lh20" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("Price")) +
                                "\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "sans-serif lh20" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("Qty")) +
                                "\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "sans-serif lh20" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("Subtotal")) +
                                "\n              "
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.skipGrouped(_vm.order.items), function(
                          item
                        ) {
                          return _c(
                            "tr",
                            {
                              key: item.item_id,
                              staticClass: "brdr-top-1 brdr-cl-bg-secondary"
                            },
                            [
                              _c(
                                "td",
                                {
                                  staticClass: "fs-medium lh25",
                                  attrs: { "data-th": _vm.$t("Product Name") }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.name) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "fs-medium lh25",
                                  attrs: { "data-th": _vm.$t("SKU") }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.part_number) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "fs-medium lh25",
                                  attrs: { "data-th": _vm.$t("Price") }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm._f("price")(
                                          item.price_incl_tax,
                                          _vm.storeView
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "fs-medium lh25 align-right",
                                  attrs: { "data-th": _vm.$t("Qty") }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(Math.round(item.qty_ordered)) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "fs-medium lh25",
                                  attrs: { "data-th": _vm.$t("Subtotal") }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm._f("price")(
                                          item.row_total_incl_tax,
                                          _vm.storeView
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("tfoot", [
                        _c(
                          "tr",
                          { staticClass: "brdr-top-1 brdr-cl-bg-secondary" },
                          [
                            _c(
                              "td",
                              {
                                staticClass: "align-right",
                                attrs: { colspan: "4" }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("Subtotal")) +
                                    "\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("price")(
                                    _vm.order.subtotal,
                                    _vm.storeView
                                  )
                                )
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "align-right",
                              attrs: { colspan: "4" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("Cost of delivery")) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("price")(
                                  parseFloat(_vm.order.shipping_amount) +
                                    parseFloat(_vm.order.payment_amount),
                                  _vm.storeView
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "align-right",
                              attrs: { colspan: "4" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("Tax")) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("price")(
                                  _vm.order.tax_amount +
                                    _vm.order.discount_tax_compensation_amount,
                                  _vm.storeView
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.order.discount_amount
                          ? _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "align-right",
                                  attrs: { colspan: "4" }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("Discount")) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("price")(
                                      _vm.order.discount_amount,
                                      _vm.storeView
                                    )
                                  )
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "align-right",
                              attrs: { colspan: "4" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("Grand total")) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("price")(
                                  _vm.order.grand_total,
                                  _vm.storeView
                                )
                              )
                            )
                          ])
                        ])
                      ])
                    ]
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row fs16 mb35" }, [
            _c("div", { staticClass: "col-xs-12 h4" }, [
              _c("h4", [_vm._v(_vm._s(_vm.$t("Order informations")))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "items-table brdr-1 brdr-cl-bg-secondary px15" },
                [
                  _c("div", { staticClass: "row" }, [
                    _vm.shippingAddress
                      ? _c("div", { staticClass: "col-sm-6 col-md-3" }, [
                          _c("h5", [
                            _vm._v(_vm._s(_vm.$t("Shipping address")))
                          ]),
                          _vm._v(" "),
                          _c("address", [
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.shippingAddress.firstname) +
                                  " " +
                                  _vm._s(_vm.shippingAddress.lastname)
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.shippingAddress.street &&
                                    _vm.shippingAddress.street[0]
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.shippingAddress.street &&
                                      _vm.shippingAddress.street[1]
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.shippingAddress.postcode) +
                                  " " +
                                  _vm._s(_vm.shippingAddress.city)
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(_vm._s(_vm.shippingAddress.country))
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.order.shipping_description
                      ? _c("div", { staticClass: "col-sm-6 col-md-3" }, [
                          _c("h5", [_vm._v(_vm._s(_vm.$t("Shipping method")))]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.order.shipping_description) +
                                " / " +
                                _vm._s(
                                  _vm._f("price")(
                                    _vm.order.shipping_amount,
                                    _vm.storeView
                                  )
                                )
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.billingAddress
                      ? _c("div", { staticClass: "col-sm-6 col-md-3" }, [
                          _c("h5", [_vm._v(_vm._s(_vm.$t("Billing address")))]),
                          _vm._v(" "),
                          _c("address", [
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.billingAddress.firstname) +
                                  " " +
                                  _vm._s(_vm.billingAddress.lastname)
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.billingAddress.street &&
                                    _vm.billingAddress.street[0]
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.billingAddress.street &&
                                      _vm.billingAddress.street[1]
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.billingAddress.postcode) +
                                  " " +
                                  _vm._s(_vm.billingAddress.city)
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(_vm._s(_vm.billingAddress.country))
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-6 col-md-3" }, [
                      _c("h5", [_vm._v(_vm._s(_vm.$t("Payment method")))]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.paymentMethod) +
                            " / " +
                            _vm._s(
                              _vm._f("price")(
                                _vm.order.payment_amount,
                                _vm.storeView
                              )
                            )
                        )
                      ])
                    ])
                  ])
                ]
              )
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }